import React from 'react';
import {connect} from 'react-redux';
import * as s from '../loading/selectors';
import './reducers';

export const Loading = connect((state, {ns, id}) => ({
    show: s.isLoading(state, ns, id),
}))(({show}) => {
    if (!show) {
        return null;
    }

    return (
        <div className="ui active dimmer">
            <div className="ui loader" />
        </div>
    );
});
